<template>
  <div class="countdown">
    <span class="countdown-title">{{ detail.biddingStatusDesc }}</span>
    <span class="countdown-count">{{ d }}</span>
    <span> 天 </span>
    <span class="countdown-count">{{ h }}</span>
    <span> 小时 </span>
    <span class="countdown-count">{{ m }}</span>
    <span> 分 </span>
    <span class="countdown-count">{{ s }}</span>
    <span> 秒 </span>
  </div>
</template>

<script>
import webSocketConnect from '@utils/common/websorket'
export default {
  mixins: [webSocketConnect],
  props: {
    nowTime: {
      type: null,
      default: Date.now()
    },
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      timeVal: 0,
      timer: null
    }
  },
  computed: {
    endTime() {
      const endTime = this.detail.biddingStatusDate || Date.now()
      return Math.floor(new Date(endTime).getTime() / 1000)
    },
    s() {
      return this.timeVal % 60
    },
    m() {
      return Math.floor(this.timeVal / 60) % 60
    },
    h() {
      return Math.floor(this.timeVal / 3600) % 24
    },
    d() {
      return Math.floor(this.timeVal / (3600 * 24))
    }
  },
  created() {
    this.timeVal = this.endTime - Math.floor(new Date(this.nowTime).getTime() / 1000)
    if (this.timeVal > 0) {
      this.timer = setInterval(this.countdown, 1000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    countdown() {
      this.timeVal = this.timeVal - 1
      if (this.timeVal <= 0) {
        this.timeVal = 0
        clearInterval(this.timer)
        this.$emit('time-down')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.countdown {
  margin-left: 15px;
  height: 32px;
  line-height: 32px;
  top: 16px;
  left: 75px;
  padding: 0 10px;
  background-color: #FFF8E3;
  font-size: 12px;
  border-radius: 3px;
  &-title {
    margin-right: 10px;
  }
  &-count {
    color: #F7B500;
  }
}
</style>
